import React from 'react';
import '../Styles/Aboutedu.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

const Aboutedu = () => {
    return (
        <div className="aboutedu-container">
        <div className="aboutedu-header">
            <h1>About Edulab</h1>
            <p>Learn more about our mission, vision, and commitment to transforming education.</p>
        </div>
        
        {/* Scroll/Icon Section similar to achievements */}
        <div className="aboutedu-cards">
            <div className="aboutedu-card">
                <div className="aboutedu-icon">
                    <i className="fas fa-award"></i>
                </div>
                <h2>Educational Excellence</h2>
                <p>Transforming education for over <strong>50,000</strong> students through strategic growth and partnerships.</p>
            </div>
            <div className="aboutedu-card">
                <div className="aboutedu-icon">
                    <i className="fas fa-rocket"></i>
                </div>
                <h2>Technology Innovation</h2>
                <p>Pioneering platform driving technological advancement across universities in Maharashtra.</p>
            </div>
            <div className="aboutedu-card">
                <div className="aboutedu-icon">
                    <i className="fas fa-globe"></i>
                </div>
                <h2>Global Programs</h2>
                <p>International programs including <strong>INTERNSHIP</strong>, <strong>STUDY ABROAD</strong>, and <strong>VOLUNTEERING</strong>.</p>
            </div>
            <div className="aboutedu-card">
                <div className="aboutedu-icon">
                    <i className="fas fa-university"></i>
                </div>
                <h2>University Management</h2>
                <p>Comprehensive ERP solutions designed for educational institutions and campus operations.</p>
            </div>
        </div>
        
        <div className="aboutedu-overview">
            <h2 className="aboutedu-title">Edulab Overview</h2>
            <p className="aboutedu-text">
                Edulab is a pioneering platform driving technological advancement across universities in Maharashtra, 
                empowering institutions to thrive in an increasingly digital and knowledge-driven economy.
            </p>
            <p className="aboutedu-text">
                With a proven track record of transforming education for over 50,000 students through strategic growth 
                and partnerships, Edulab is redefining educational access and operational efficiency for higher 
                education institutions across the state.
            </p>
            <p className="aboutedu-text">
                Our mission is to bridge the digital divide by fostering an inclusive transformation where technology 
                enhances educational equity, learning experiences, and future readiness. We go beyond digital adoption 
                to create a fully integrated, technology-centric academic environment that empowers both students and 
                institutions to excel in the 21st-century knowledge society.
            </p>
            <p className="aboutedu-text">
                We ensure cultural integration through our programs like INTERNATIONAL INTERNSHIP, STUDY ABROAD, GAP YEAR, 
                and INTERNATIONAL VOLUNTEERING. All our programs are designed to provide students with opportunities to stay 
                and interact with people from multiple countries, be supported by our local representatives in each destination, 
                and ultimately gain a deep understanding of local cultures and traditions—helping them become globally literate.
            </p>
        </div>
    </div>
    
    );
}

export default Aboutedu;
